import React, { useState, useEffect } from 'react';
import successBubble from '../../assets/icons/common/success-bubble.svg';
import './Toast.css';
import { FormattedMessage } from 'react-intl';

const Toast = ({ checkSites }) => {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const showToast = (message, type) => {
      setToast({ id: checkSites, message, type, show: true });
    };

    const removeToast = () => {
      setToast(null);
    };

    if (checkSites) {
      showToast(checkSites, 'danger');
    } else {
      removeToast();
    }
  }, [checkSites]);

  return (
    <>
      {toast && (
        <div
          id="toastNoSite"
          className={`toast toast-container ${toast.show ? 'show' : ''} ${toast.type} `}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          onClick={() => setToast(null)}
        >
          <div className="toast-body">
            {toast.type === 'success' && <img src={successBubble} alt="Success" className="toast-icon" />}
            <FormattedMessage id={toast.message} />
          </div>
          <button type="button" className="btn-close" onClick={() => setToast(null)}></button>
        </div>
      )}
    </>
  );
};

export default Toast;
